import { Navigate, useRoutes } from 'react-router-dom';
// config
import SimpleTranslateMainLayout from 'src/layouts/main/simpletranslate';
import SimpleTMainLayout from 'src/layouts/main/simpletai';
//
import { mainRoutes, SimpleTranslateHomePage, SimpleAiHomePage } from './main';

import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';
import { supportRoutes } from './support';
import { docsRoutes } from './docs';
import { legalRoutes } from './legal';

// ----------------------------------------------------------------------

export default function Router() {

  return useRoutes([
    {
      path: '/',
      element: (
        <SimpleTranslateMainLayout>
          <SimpleTranslateHomePage />
        </SimpleTranslateMainLayout>
      ),
      children: [
        { path: 'simpletranslate', element: <SimpleTranslateHomePage /> },
      ],
    },
    {
      path: '/simpletai',
      element: (
        <SimpleTMainLayout>
          <SimpleAiHomePage />
        </SimpleTMainLayout>
      ),
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Main routes
    ...mainRoutes,

    // Support routes
    ...supportRoutes,

    // Legal routes
    ...legalRoutes,

    // Docs routes
    ...docsRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
